import React from "react";
import { Accordion} from "@trussworks/react-uswds";
import '@trussworks/react-uswds/lib/index.css';
import '@trussworks/react-uswds/lib/uswds.css';
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { logPageView } from "../utils/analytics";
import styled from "styled-components";
import { AccordionItemProps } from "@trussworks/react-uswds/lib/components/Accordion/Accordion";
import { AnalyticsAction, logEvent } from "../utils/analytics";
import { handlePageLoad } from "../utils/accessibility";
import ReactMarkdown from "react-markdown";

// const StyledAccordionContent = styled.div`
//   margin: 2rem auto 3rem;
//   background: transparent;
// `;
const StyledAccordionUpdateContent = styled.div`
  display:inline;
  overflow-wrap:normal;
  font-family:'Comfortaa';
  white-space: pre-wrap;
  white-space: -moz-pre-wrap;
  white-space: -pre-wrap;
  white-space: -o-pre-wrap;
  word-wrap: break-word;
  background: transparent;
  background-color: #c8bddc;
`;


// const StyledAccordionItem = styled.div`
//  background: transparent;
//  `

function FAQ() {
  useEffect(() => {
    handlePageLoad();
    logPageView();
  }, []);

  const { t } = useTranslation();

  function getAccordionItem(itemKey: string): AccordionItemProps {
    return {
      title: <span className={"faq-question font-body dark_blue"} >{`${t(`${itemKey}Question`)}`}</span>,
      expanded: false,
      className: "faqAccordion",
      id: itemKey,
      content: (
        <div className={"divAccordion dark_blue"} key={itemKey} >
          {itemKey === "toolkit" ? (
            <>
              <span className={"dark_blue"}>{`${t("answerAbbreviation")}. ${t("toolkitAnswer")}`}</span>
              <ul>
                <li className={"dark_blue"}>
                  {t("toolkitAnswerDownloadFAQ")}{" "}
                  {/* For whatever reason using react-router <Link> makes these only function as page redirects,
                      not content downloads even with 'download' attribute, so use vanilla <a> instead */}
                  <a download href="/resources/BHA OwnPath FAQs (EN).pdf" className={"body_font dark_blue"}>
                    {t("languageValuesEnglish").split("/")[0].trim()}
                  </a>
                  ,{" "}
                  <a download href="/resources/BHA OwnPath FAQs (ES).pdf" className={"body_font dark_blue"}>
                    {t("languageValuesSpanish").split("/")[0].trim()}
                  </a>
                </li>
                <li className={"body_font dark_blue"}>
                  {t("toolkitAnswerDownloadOnePager")}{" "}
                  <a download href="/resources/BHA OwnPath one pager (EN).pdf" className={"body_font dark_blue"}>
                    {t("languageValuesEnglish").split("/")[0].trim()}
                  </a>
                  ,{" "}
                  <a download href="/resources/BHA OwnPath one pager (ES).pdf" className={"body_font dark_blue"}>
                    {t("languageValuesSpanish").split("/")[0].trim()}
                  </a>
                </li>
              </ul>
            </>
            ): itemKey === "updateInfo" ? (
              <StyledAccordionUpdateContent>
              <p className={"body_font dark_blue"}>{`${t("answerAbbreviation")}. ${t("updateInfoAnswer")}` }</p>
              <p className={"body_font dark_blue"}>{`${t("updateInfoFirstLine")}`} <a onClick={() => logEvent(AnalyticsAction.FAQProviderUpdateRequestInclusion)} href="https://docs.google.com/forms/d/e/1FAIpQLSefCInI_nOCv01nv-4gxaPeaQwyGxAfQqdJUQ09UVcKAxVIaA/viewform" target="_blank" className="usa-link--external" rel="noreferrer">{`${t("updateInfoFirstSubmit")}`}
                 </a>
              </p>
              <p className={"body_font dark_blue"}>{`${t("updateInfoSecondLine")}`} 
                <a onClick={() => logEvent(AnalyticsAction.FAQProviderUpdateReportMissing)} href={t("complaintFormUrl")} target="_blank" className="usa-link--external" rel="noreferrer">{`${t("updateInfoSecondSubmit")}`}</a>
              </p>
              </StyledAccordionUpdateContent>
            
          ) : (
            <div className="markdown-container">
            <ReactMarkdown>
              {`${t(`${itemKey}Answer`)}`}
            </ReactMarkdown></div>
          )}
        </div>
      ),
      headingLevel: "h2",
    };
  }
  return (
    <div id="container1" className="divContainer ">
      <div className="flex-justify-left row divRow nice_font dark_blue" >
        <span className="faq-header">{t("faqPageHeading")}</span>
      </div>
      <div style={{"width":"95%"}} className=" nice_font dark_blue" >
        <Accordion
          items={[
            "whatIsColoradoLifts",
            "howCanSomeoneGetCareThroughColoradoLifts",
            "shouldICallColoradoLiftsIfImInACrisis",
            "whoCanUseColoradoLifts",
            "whyIsColoradoLiftsBetterThanTheOldSystem",
            "doINeedToEnrollToReceiveServices",
            "isColoradoLiftsTheSameAsTheOwnPathCareDirectory",
            "howManyProvidersAreInTheLiftsNetwork",
            "whatTypesOfServicesDoesColoradoLiftsOffer",
            "whyArentAllBehavioralHealthcareProvidersListedOnTheOwnPathDirectory",
            "canITalkToSomeoneAboutHowToGetCare",
            "whereCanIFindMoreBehavioralHealthResources",
            "whereCanIAskQuestionsOrProvideFeedback"
          ].map(getAccordionItem)}
          bordered={false}
        />
      </div>
    </div>
  );
}

export default FAQ;
